import React, { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiCheckCircle, FiAlertCircle, FiX } = FiIcons;

export default function Toast({ toasts, removeToast }) {
  return (
    <div className="fixed bottom-8 right-8 z-[100] flex flex-col gap-4 pointer-events-none">
      <AnimatePresence>
        {toasts.map((toast) => (
          <motion.div
            key={toast.id}
            initial={{ opacity: 0, x: 50, scale: 0.9 }}
            animate={{ opacity: 1, x: 0, scale: 1 }}
            exit={{ opacity: 0, x: 20, scale: 0.9 }}
            className="pointer-events-auto min-w-[300px] bg-smoke-light border border-white/10 p-4 shadow-2xl flex items-center justify-between group"
          >
            <div className="flex items-center gap-3">
              <div className={toast.type === 'error' ? 'text-red-500' : 'text-ember'}>
                <SafeIcon icon={toast.type === 'error' ? FiAlertCircle : FiCheckCircle} className="w-5 h-5" />
              </div>
              <p className="text-sm text-linen/90 font-medium">{toast.message}</p>
            </div>
            <button 
              onClick={() => removeToast(toast.id)}
              className="text-linen/20 hover:text-linen transition-colors ml-4"
            >
              <SafeIcon icon={FiX} className="w-4 h-4" />
            </button>
          </motion.div>
        ))}
      </AnimatePresence>
    </div>
  );
}